import React, { useEffect, useState } from 'react';
import { trackAndNavigate } from '../utils/pixel';
import { useTrackSection } from '../utils/useTrackSection';
const comparisonRows = [{
  without: 'Improvisar',
  with: 'Tener sistema'
}, {
  without: 'Perder tiempo',
  with: 'Ahorrar horas'
}, {
  without: 'Consultas desordenadas',
  with: 'Sesiones claras'
}, {
  without: 'Dudar qué hacer',
  with: 'Trabajar con criterio'
}, {
  without: 'Cobrar con inseguridad',
  with: 'Mostrar más valor'
}];
const TIMER_KEY = 'megapack_nutricion_countdown_end';
const DURATION_MS = 24 * 60 * 60 * 1000;
const CHECKOUT_URL = 'https://www.bibliotecaprofesional.com/cart/48299489689770:1';
function getEndTime(): number {
  if (typeof window === 'undefined') return Date.now() + DURATION_MS;
  const stored = localStorage.getItem(TIMER_KEY);
  if (stored) {
    const end = parseInt(stored, 10);
    if (end > Date.now()) return end;
  }
  const end = Date.now() + DURATION_MS;
  localStorage.setItem(TIMER_KEY, String(end));
  return end;
}
function getTimeLeft(endTime: number) {
  const diff = Math.max(0, endTime - Date.now());
  return {
    hours: Math.floor(diff / (1000 * 60 * 60)),
    minutes: Math.floor(diff % (1000 * 60 * 60) / (1000 * 60)),
    seconds: Math.floor(diff % (1000 * 60) / 1000)
  };
}
export function DarkCTA() {
  useTrackSection('dark-cta', 'Final CTA Section');
  const [endTime] = useState<number>(() => getEndTime());
  const [timeLeft, setTimeLeft] = useState(() => getTimeLeft(endTime));
  useEffect(() => {
    const timer = setInterval(() => setTimeLeft(getTimeLeft(endTime)), 1000);
    return () => clearInterval(timer);
  }, [endTime]);
  const pad = (n: number) => String(n).padStart(2, '0');
  return <section id="dark-cta" className="w-full px-4 sm:px-6 lg:px-8 py-14 sm:py-16 text-gray-900 text-base leading-6" style={{
    background: 'linear-gradient(180deg, rgb(240,253,244) 0%, rgb(187,247,208) 35%, rgb(255,255,255) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-90">
      <div className="mx-auto max-w-3xl text-center" data-id="element-91">
        <h2 className="text-3xl sm:text-5xl font-black text-gray-900 m-0 mb-3 leading-tight" data-id="element-92">
          La próxima consulta puede ser distinta.
        </h2>

        <p className="text-lg sm:text-2xl font-black text-green-700 m-0 mb-8" data-id="element-93">
          La decisión es simple:
        </p>

        <div className="mx-auto max-w-xl mb-8 overflow-hidden rounded-2xl bg-white border border-green-200 shadow-md" data-id="element-94">
          <div className="grid grid-cols-2" data-id="element-95">
            <div className="bg-red-50 px-4 py-3 text-center text-xs font-black text-red-600" data-id="element-96">
              SEGUIR IGUAL
            </div>

            <div className="bg-green-50 px-4 py-3 text-center text-xs font-black text-green-700" data-id="element-97">
              CON MEGAPACK
            </div>
          </div>

          {comparisonRows.map((row, i) => <div key={i} className="grid grid-cols-2 border-t border-gray-100" data-id="element-98">
              <div className="px-4 py-3 text-center text-sm font-bold text-gray-500" data-id="element-99">
                ✗ {row.without}
              </div>

              <div className="px-4 py-3 text-center text-sm font-black text-gray-900 bg-green-50/40" data-id="element-100">
                ✓ {row.with}
              </div>
            </div>)}
        </div>

        <div className="mb-7 rounded-2xl bg-white border border-green-700/20 shadow-md px-5 py-5" data-id="element-101">
          <p className="text-sm font-black text-gray-900 m-0 mb-1" data-id="element-102">
            6 Tomos + 5 Bonos Profesionales
          </p>

          <div className="my-3" data-id="element-103">
            <p className="text-sm text-gray-400 line-through font-black m-0" data-id="element-104">
              $67.990
            </p>
            <p className="text-5xl sm:text-6xl font-black text-green-700 leading-none m-0" data-id="element-105">
              $29.990
            </p>
          </div>

          <p className="text-xs font-bold text-gray-500 m-0" data-id="element-106">
            Precio de lanzamiento · Ahorrás $38.000 hoy
          </p>
        </div>

        <div className="mb-6" data-id="element-107">
          <p className="font-black text-red-600 m-0 mb-2" data-id="element-108">⏰ Termina en:</p>

          <div className="inline-flex items-center justify-center gap-2 rounded-xl bg-white border border-red-200 shadow-sm px-4 py-3 mx-auto" data-id="element-109">
            {[{
            value: pad(timeLeft.hours),
            label: 'hs'
          }, {
            value: ':',
            label: null
          }, {
            value: pad(timeLeft.minutes),
            label: 'min'
          }, {
            value: ':',
            label: null
          }, {
            value: pad(timeLeft.seconds),
            label: 'seg'
          }].map((item, i) => item.label === null ? <span key={i} className="-mt-3 text-3xl sm:text-5xl font-black leading-none text-red-600" data-id="element-110">
                  :
                </span> : <div key={i} className="flex flex-col items-center min-w-[50px] sm:min-w-[70px]" data-id="element-111">
                  <span className="text-3xl sm:text-5xl font-black tabular-nums leading-none text-red-600" data-id="element-112">
                    {item.value}
                  </span>
                  <span className="mt-1 text-[10px] uppercase tracking-wide text-gray-500" data-id="element-113">
                    {item.label}
                  </span>
                </div>)}
          </div>
        </div>

        <a href={CHECKOUT_URL} onClick={e => {
        e.preventDefault();
        trackAndNavigate('InitiateCheckout', {
          content_name: 'Megapack Nutrición Resuelta',
          content_category: 'Nutrición Resuelta',
          value: 29990,
          currency: 'ARS'
        }, CHECKOUT_URL);
      }} className="cta-breathe mx-auto block w-full max-w-2xl bg-green-700 text-white text-center text-lg sm:text-2xl font-black rounded-2xl py-5 no-underline transition-colors hover:bg-green-800" data-id="element-114">
          ✅ SÍ, QUIERO MI MEGAPACK AHORA
        </a>

        <p className="text-center text-[13px] font-semibold text-gray-600 mt-4 mb-0" data-id="element-115">
          ⚡ Acceso inmediato · 🛡️ Garantía 7 días · 🔒 Pago seguro · 💳 Mercado
          Pago
        </p>
      </div>
    </section>;
}